<script>
  import { onMount, onDestroy } from 'svelte';
  import { currentChatId, setCurrentChat } from './stores.js';
  import ChatList from '../routes/ChatList.svelte';
  import Chat from '../routes/Chat.svelte';
  import Settings from '../routes/Settings.svelte';
  import AppSettings from '../routes/AppSettings.svelte';
  import Context from '../routes/Context.svelte';

  let route = 'chats';
  let params = {};

  // Печатный вид (этап 21) — отдельным чанком: на холодном старте PWA он не нужен,
  // а стартовый набор после этапа 20 держим маленьким.
  let PrintScreen = null;
  // Библиотека шаблонов (этап 24) — тоже отдельным чанком.
  let TemplatesScreen = null;

  async function loadTemplatesScreen() {
    if (TemplatesScreen) {
      return;
    }
    try {
      TemplatesScreen = (await import('../routes/Templates.svelte')).default;
    } catch (error) {
      console.warn('Router: templates screen failed to load', error);
    }
  }

  async function loadPrintScreen() {
    if (PrintScreen) {
      return;
    }
    try {
      PrintScreen = (await import('../routes/Print.svelte')).default;
    } catch (error) {
      console.warn('Router: print screen failed to load', error);
    }
  }

  function parseHash() {
    const hash = window.location.hash.slice(1) || '/chats';
    const [path, queryString = ''] = hash.split('?');
    const parts = path.split('/').filter(Boolean);
    const query = new URLSearchParams(queryString);
    
    if (parts[0] === 'chat' && parts[1]) {
      route = 'chat';
      params = {
        chatId: parts[1],
        messageId: query.get('messageId') || null,
        // Этап 23: сообщение внутри свёрнутого этапа открывается окном этого этапа.
        stageId: query.get('stage') || null,
      };
      setCurrentChat(parts[1]);
    } else if (parts[0] === 'settings' && parts[1]) {
      route = 'settings';
      params = { chatId: parts[1] };
    } else if (parts[0] === 'app-settings') {
      route = 'app-settings';
      params = {};
    } else if (parts[0] === 'print' && parts[1]) {
      // Этап 21: печатный вид чата. `?message=<id>` — печать одного обмена.
      route = 'print';
      params = {
        chatId: parts[1],
        messageId: query.get('message') || null,
      };
      loadPrintScreen();
    } else if (parts[0] === 'context' && parts[1]) {
      // Этап 10: экран контекста чата (мозг облако/дача, статус дачи) — свайп влево из чата.
      route = 'context';
      params = { chatId: parts[1] };
    } else if (parts[0] === 'templates') {
      route = 'templates';
      params = {};
      currentChatId.set(null);
      loadTemplatesScreen();
    } else {
      route = 'chats';
      params = {};
      currentChatId.set(null);
    }
  }

  function handleHashChange() {
    parseHash();
  }

  onMount(() => {
    parseHash();
    window.addEventListener('hashchange', handleHashChange);
  });

  onDestroy(() => {
    window.removeEventListener('hashchange', handleHashChange);
  });

  // Navigation helpers
  export function navigateTo(path) {
    window.location.hash = path;
  }
</script>

{#if route === 'chats'}
  <ChatList />
{:else if route === 'chat'}
  <Chat chatId={params.chatId} focusMessageId={params.messageId} focusStageId={params.stageId} />
{:else if route === 'settings'}
  <Settings chatId={params.chatId} />
{:else if route === 'app-settings'}
  <AppSettings />
{:else if route === 'context'}
  <Context chatId={params.chatId} />
{:else if route === 'templates'}
  {#if TemplatesScreen}
    <svelte:component this={TemplatesScreen} />
  {/if}
{:else if route === 'print'}
  {#if PrintScreen}
    <svelte:component this={PrintScreen} chatId={params.chatId} exchangeMessageId={params.messageId} />
  {/if}
{/if}

<style>
  :global(.app) > :global(*) {
    min-height: 0;
  }
</style>
